import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, toast, BackdropLoader } from '@livable/saas-react-components';
import { Button, IconButton, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { FilePreviewModal } from '../FilePreviewModal';
import { RemoveFileModal } from '../RemoveFileModal';
import { useTranslation } from 'react-i18next';
export default function DropFileUploader(_ref) {
  let billSettingsAccepted = _ref.billSettingsAccepted,
    callback = _ref.callback,
    disabled = _ref.disabled,
    fileName = _ref.fileName,
    fileSize = _ref.fileSize,
    isFileUploadingAccepted = _ref.isFileUploadingAccepted,
    isUtilityForm = _ref.isUtilityForm,
    uploadStartedCallback = _ref.uploadStartedCallback,
    filePreviewLink = _ref.filePreviewLink,
    isPreviewForm = _ref.isPreviewForm,
    noPreview = _ref.noPreview,
    validator = _ref.validator,
    isDisabledParent = _ref.isDisabledParent,
    calculateFormFromModal = _ref.calculateFormFromModal,
    selectedCycleStartDate = _ref.selectedCycleStartDate,
    editFileCallback = _ref.editFileCallback,
    utility = _ref.utility,
    openBillModal = _ref.openBillModal,
    setOpenBillModal = _ref.setOpenBillModal,
    isOnlyUploader = _ref.isOnlyUploader;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const fileInputRef = useRef();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDrag = _useState2[0],
    setIsDrag = _useState2[1];
  const _useState3 = useState(fileName || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFilePreviewModalOpen = _useState6[0],
    setIsFilePreviewModalOpen = _useState6[1];
  useEffect(() => {
    setValue(fileName);
  }, [fileName]);
  const handleFileUpload = async e => {
    if (e.target.files.length > 0) {
      var _uploadedFileResult;
      // NOTE: base is 1MB * 100
      if (e.target.files[0].size >= 1048576 * 100) {
        toast('error', {
          body: ['File is too large, maximum file size is 100 MB']
        });
        return;
      }
      setValue(e.target.files[0].name);
      if (uploadStartedCallback) uploadStartedCallback();
      if (noPreview) return callback(e.target.files[0]);
      let uploadedFileResult;
      if (store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled) {
        uploadedFileResult = await store.files.uploadFileViaPresignedUrlExperimentAsync.run({
          file: e.target.files[0],
          createdBy: store.account.userProfile.id
        });
      } else {
        uploadedFileResult = await store.files.uploadFileAsync.run({
          file: e.target.files[0]
        });
      }

      // const uploadedFileResult = await store.files.uploadFileAsync.run({
      //   file: e.target.files[0],
      // });

      if ((_uploadedFileResult = uploadedFileResult) !== null && _uploadedFileResult !== void 0 && _uploadedFileResult.isSuccessful) {
        const fileId = uploadedFileResult.response;
        // NOTE: after successfully load file id would be received and it should be assigned to right place

        callback(fileId);
      } else {
        callback(uploadedFileResult);
      }
    }
  };
  const handleDelete = () => {
    setValue('');
    fileInputRef.current.value = null;
    if (typeof callback === 'function') {
      callback(null);
    }
  };
  const onDragStart = () => {
    setIsDrag(true);
  };
  const onDragEnd = () => {
    setIsDrag(false);
  };
  useEffect(() => {
    if (isUtilityForm && !isFileUploadingAccepted && billSettingsAccepted) {
      fileInputRef.current.click();
      store.files.setFileUploadingAccepted();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billSettingsAccepted]);
  useEffect(() => {
    if (!!openBillModal) setIsFilePreviewModalOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openBillModal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(value && value.length ? 'active' : '', " ").concat(classes.dropArea, " ").concat(isDrag ? 'drag' : '', " ").concat(disabled ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.files.uploadFileViaPresignedUrlExperimentAsync.inProgress || store.files.uploadFileAsync.inProgress
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.fileInfo, " ").concat(value && value.length > 0 ? '' : 'center')
  }, !noPreview && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.preview,
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "link"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.name
  }, value && value.length > 0 && /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("span", null, value)), (!value || value.length === 0) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    variant: "h5"
  }, "Drag and drop here or ", /*#__PURE__*/React.createElement("span", null, "click to browse from your files ")), store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('general.upload_file_size_limit_note')))), !isOnlyUploader && !noPreview && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.previewBill
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    },
    'custom-attribute': '313-DropFileUploader'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-in"
  }), /*#__PURE__*/React.createElement("span", null, "Preview bill")))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, !isOnlyUploader && !disabled && value && value.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.remove
  }, /*#__PURE__*/React.createElement(RemoveFileModal, {
    callback: handleDelete,
    trigger: /*#__PURE__*/React.createElement(IconButton, {
      'custom-attribute': '314-DropFileUploader'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }))
  })), /*#__PURE__*/React.createElement("input", {
    type: "file",
    ref: fileInputRef,
    disabled: disabled,
    onChange: handleFileUpload,
    onDragEnter: onDragStart,
    onFocus: onDragStart,
    onDragLeave: onDragEnd,
    onBlur: onDragEnd,
    onDrop: onDragEnd
  })))), !isOnlyUploader && /*#__PURE__*/React.createElement(FilePreviewModal, {
    docUri: filePreviewLink,
    fileName: fileName,
    fileSize: fileSize,
    isOpen: isFilePreviewModalOpen,
    handleClose: () => {
      if (setOpenBillModal) setOpenBillModal(false);
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    },
    handleOpen: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    validator: validator,
    isPreviewForm: isPreviewForm,
    isDisabledParent: isDisabledParent,
    calculateFormFromModal: calculateFormFromModal,
    selectedCycleStartDate: selectedCycleStartDate,
    utility: utility,
    handleDelete: handleDelete,
    uploadEditedFile: editFileCallback,
    noFooter: isPreviewForm
  }));
}